import {
    ApiBaseService,
    type ApiServiceConfig,
} from "~/services/ApiBaseService";
import type { ApiResponse } from "~/types/ApiResponse";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import type { Connection } from "~/models/Connection";

interface FacebookPageBusiness {
    id: string | number;
    name: string;
}

export interface FacebookPage {
    id: string | number;
    name: string;
    access_token: string;
    category: string;
    business?: FacebookPageBusiness;
    subscribed?: boolean; // We'll add this client-side
}

export interface FacebookForm {
    id: string | number;
    name: string;
    status: string;
    page_id: string | number;
}

export default class FacebookService extends ApiBaseService {
    protected uuid: string;

    constructor(uuid: string, config: ApiServiceConfig) {
        super(config);

        this.uuid = uuid;
    }

    public getPages(): Promise<ApiResponse<FacebookPage[]>> {
        return this.request(
            this.route(
                "api.connections.facebook.pages.index",
                "/connections/facebook/{connection}/pages",
                {
                    connection: this.uuid,
                }
            ),
            {
                method: "GET",
            }
        );
    }

    public async getForms<T = FacebookForm>(pageId: string | number): Promise<ApiResponse<T[]>> {
        return this.request(
            this.route(
                "api.connections.facebook.page.forms.index",
                "/connections/facebook/{connection}/page/{pageId}/forms",
                {
                    connection: this.uuid,
                    pageId: pageId
                }
            ),
            {
                method: "GET",
            }
        );
    }

    public subscribePage(pageId: string): Promise<ApiResponse<any>> {
        return this.request(
            this.route(
                "api.connections.facebook.pages.subscribe",
                "/connections/facebook/{connection}/pages/{page}/subscribe",
                {
                    connection: this.uuid,
                    page: pageId,
                }
            ),
            {
                method: "POST",
            }
        );
    }

    public unsubscribePage(pageId: string): Promise<ApiResponse<any>> {
        return this.request(
            this.route(
                "api.connections.facebook.pages.unsubscribe",
                "/connections/facebook/{connection}/pages/{page}/unsubscribe",
                {
                    connection: this.uuid,
                    page: pageId,
                }
            ),
            {
                method: "DELETE",
            }
        );
    }

    public getConnectionDropdown(
        connection: Connection,
        options: Partial<{
            onProvision: (e: PointerEvent) => void;
            onDelete: (e: PointerEvent) => void;
        }> = {},
    ) {
        return [
            [
                {
                    label: `Disconnect`,
                    icon: faTrash,
                    click: (e: PointerEvent) => {
                        if (options.onDelete) options.onDelete(e);
                    },
                },
            ],
        ];
    }
}
